import { render, staticRenderFns } from "./ViewPartnershipType.vue?vue&type=template&id=92a1ace4&scoped=true&"
import script from "./ViewPartnershipType.vue?vue&type=script&lang=js&"
export * from "./ViewPartnershipType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a1ace4",
  null
  
)

export default component.exports